import Raven from 'raven-js';

const LIBRARY_NAME = 'ui-product-approvals';

type RavenCaptureOptions = NonNullable<
  Parameters<typeof Raven.captureException>[1]
>;

export const captureException = (
  error: unknown,
  options: RavenCaptureOptions = {}
) => {
  const err = error instanceof Error ? error : new Error(String(error));
  Raven.captureException(err, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
};
